import { createContext, useContext } from 'react';

import noop, { NoOp } from 'utils/noop';

import { TakeoverIntent, UploadCompleteConfig } from '../types';

export interface TakeoverContextState {
  currentIntent: TakeoverIntent;
  setCurrentIntent: (intent: TakeoverIntent) => void;
  initialIntent: TakeoverIntent;
  isOpen: boolean;
  isWarningOverlayOpen: boolean;
  onClose: (warnBeforeClose: boolean, onConfirmClose: NoOp) => void;
  onCloseWarningOverlay: NoOp;
  onEditFiles: NoOp;
  onImportFromUrl: NoOp;
  onNewFiles: NoOp;
  onUploadComplete: (config: UploadCompleteConfig) => void;
}

export const takeoverContextDefaults: TakeoverContextState = {
  currentIntent: TakeoverIntent.UPLOAD,
  setCurrentIntent: noop,
  initialIntent: TakeoverIntent.UPLOAD,
  isOpen: false,
  isWarningOverlayOpen: false,
  onClose: noop,
  onCloseWarningOverlay: noop,
  onEditFiles: noop,
  onImportFromUrl: noop,
  onNewFiles: noop,
  onUploadComplete: noop,
};

export const TakeoverContext = createContext<TakeoverContextState>(takeoverContextDefaults);

export const useTakeoverContext = () => useContext(TakeoverContext);
